<template>
  <footer :class="$style.ctn">
    <a :class="$style.logo" aria-label="Interactive Sandbox" href="https://any.run" target="_blank">
      <SvgIcon width="130" height="55" src="icon-sprite.svg#logo_with_signature" />
    </a>
    <div :class="$style.text">
      <div>Interactive malware hunting service ANY.RUN</div>
      <div>
        © 2017-{{ root.meta.copyrightYear }}
        <a href="https://any.run" target="_blank">ANY.RUN</a> LLC. ALL RIGHTS RESERVED
      </div>
    </div>
    <div :class="$style.crumbs">
      <a href="https://any.run" target="_blank">ANY.RUN</a>
      <div />
      <a href="https://any.run/malware-reports/" target="_blank">Reports</a>
      <div />
      <span :class="$style.name">{{ root.general.mainObject.value }}</span>
    </div>
  </footer>
</template>

<script>
import { defineComponent } from 'vue';
import SvgIcon from './SvgIcon.vue';

export default defineComponent({
  components: { SvgIcon },
  inject: ['root'],
});
</script>

<style lang="scss" module>
* + .ctn {
  margin-top: 60px;
}
.ctn {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 25px 28px;
}
.text {
  font-size: 12px;
  color: rgba(63, 71, 87, 0.5);
  align-self: center;
  display: grid;
  grid-gap: 6px;
  a {
    color: #00b0e8;
    text-decoration: underline;

    @media print {
      text-decoration: none;
      color: #2f3543;
    }
  }
}
.crumbs {
  grid-column: span 2;
  display: grid;
  grid-gap: 6px;
  grid-auto-flow: column;
  justify-content: flex-end;

  & > * {
    font-size: 12px;
    color: rgba(63, 71, 87, 0.5);
  }
  & > a {
    text-decoration: underline;
  }

  & > div {
    &::before {
      content: '/';
    }
  }

  @media print {
    display: none;
  }
}
.name {
  display: block;

  white-space: nowrap;
  max-width: 500px;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
